import Commons from '../../../Services/Common/Common';

export const WOS_BASIC_Schema = {
  mapper: {
    /** useSearch1 → GetWosBasicR1 (SP_WOS_BASIC_R1) */
    search1: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      SearchText: (context) =>
        Commons.EncryptAES(context.searchText ?? '') || '',
      UserId: (context) => context.userInfo?.userid ?? '',
    },
  },
};
